import { IAvatarInfoCardTileData } from '@faire/web-api--source/indigofair/data/IAvatarInfoCardTileData';
import { IBrandInformationHeaderTile } from '@faire/web-api--source/indigofair/data/IBrandInformationHeaderTile';
import { IBrandPromoTile } from '@faire/web-api--source/indigofair/data/IBrandPromoTile';
import { IBrandReviewTile } from '@faire/web-api--source/indigofair/data/IBrandReviewTile';
import { IBrandTile } from '@faire/web-api--source/indigofair/data/IBrandTile';
import { IBrandVideoTile } from '@faire/web-api--source/indigofair/data/IBrandVideoTile';
import { ICategoryTile } from '@faire/web-api--source/indigofair/data/ICategoryTile';
import { ICategoryWithFilterTile } from '@faire/web-api--source/indigofair/data/ICategoryWithFilterTile';
import { ICategoryWithProductTile } from '@faire/web-api--source/indigofair/data/ICategoryWithProductTile';
import { IDeliveredBrandOrder } from '@faire/web-api--source/indigofair/data/IDeliveredBrandOrder';
import { IDynamicGridItemCircle } from '@faire/web-api--source/indigofair/data/IDynamicGridItemCircle';
import { IDynamicGridItemRectangle } from '@faire/web-api--source/indigofair/data/IDynamicGridItemRectangle';
import { IFilterPill } from '@faire/web-api--source/indigofair/data/IFilterPill';
import { IFlashSaleTile } from '@faire/web-api--source/indigofair/data/IFlashSaleTile';
import { IGridTile } from '@faire/web-api--source/indigofair/data/IGridTile';
import { IIconTextListItem } from '@faire/web-api--source/indigofair/data/IIconTextListItem';
import { IIconTextTile } from '@faire/web-api--source/indigofair/data/IIconTextTile';
import { IImageOnlyProductTile } from '@faire/web-api--source/indigofair/data/IImageOnlyProductTile';
import { IImageTextTile } from '@faire/web-api--source/indigofair/data/IImageTextTile';
import { IInsightTile } from '@faire/web-api--source/indigofair/data/IInsightTile';
import { ILargeBrandTile } from '@faire/web-api--source/indigofair/data/ILargeBrandTile';
import { ILayoutElementImageFanTile } from '@faire/web-api--source/indigofair/data/ILayoutElementImageFanTile';
import { ILeanBrandTile } from '@faire/web-api--source/indigofair/data/ILeanBrandTile';
import { ILeanProductTile } from '@faire/web-api--source/indigofair/data/ILeanProductTile';
import { ILeanProductWithBrandTile } from '@faire/web-api--source/indigofair/data/ILeanProductWithBrandTile';
import { IPartOfCollectionElementData } from '@faire/web-api--source/indigofair/data/IPartOfCollectionElementData';
import { IProduct } from '@faire/web-api--source/indigofair/data/IProduct';
import { IProductToken } from '@faire/web-api--source/indigofair/data/IProductToken';
import { IProductWithBrandTile } from '@faire/web-api--source/indigofair/data/IProductWithBrandTile';
import { IQuickAddProductTile } from '@faire/web-api--source/indigofair/data/IQuickAddProductTile';
import { IReviewableBrandOrder } from '@faire/web-api--source/indigofair/data/IReviewableBrandOrder';
import { ISearchQueryTile } from '@faire/web-api--source/indigofair/data/ISearchQueryTile';
import { ISimpleBrandTile } from '@faire/web-api--source/indigofair/data/ISimpleBrandTile';
import { ISimpleImageTitle } from '@faire/web-api--source/indigofair/data/ISimpleImageTitle';
import { ISimpleTextTile } from '@faire/web-api--source/indigofair/data/ISimpleTextTile';
import { ITestimonialTile } from '@faire/web-api--source/indigofair/data/ITestimonialTile';

export namespace ILayoutElementData {
  /**
   * Return an instance of ILayoutElementData with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ILayoutElementData>
  ): ILayoutElementData =>
    ({
      ...(partial ?? {}),
    }) as ILayoutElementData;
}

export interface ILayoutElementData {
  brand_tile: IBrandTile | undefined;
  flash_sale_tile: IFlashSaleTile | undefined;
  category_tile: ICategoryTile | undefined;
  /**
   * @deprecated
   */
  brand_promo_tile: IBrandPromoTile | undefined;
  large_brand_tile: ILargeBrandTile | undefined;
  simple_brand_tile: ISimpleBrandTile | undefined;
  /**
   * Deprecated! Use LeanProductTile instead.
   * @deprecated
   */
  product: IProduct | undefined;
  /**
   * Deprecated! Use LeanProductWithBrandTile instead.
   * @deprecated
   */
  product_with_brand_tile: IProductWithBrandTile | undefined;
  simple_text_tile: ISimpleTextTile | undefined;
  testimonial_tile: ITestimonialTile | undefined;
  brand_video_tile: IBrandVideoTile | undefined;
  reviewable_brand_order: IReviewableBrandOrder | undefined;
  search_query_tile: ISearchQueryTile | undefined;
  category_with_filter_tile: ICategoryWithFilterTile | undefined;
  simple_image_title: ISimpleImageTitle | undefined;
  image_only_product_tile: IImageOnlyProductTile | undefined;
  lean_product_tile: ILeanProductTile | undefined;
  lean_product_with_brand_tile: ILeanProductWithBrandTile | undefined;
  image_text_tile: IImageTextTile | undefined;
  lean_brand_tile: ILeanBrandTile | undefined;
  category_with_product_tile: ICategoryWithProductTile | undefined;
  insight_tile: IInsightTile | undefined;
  brand_review_tile: IBrandReviewTile | undefined;
  quick_add_product_tile: IQuickAddProductTile | undefined;
  part_of_collection_element_data: IPartOfCollectionElementData | undefined;
  grid_tile: IGridTile | undefined;
  dynamic_grid_item_circle: IDynamicGridItemCircle | undefined;
  dynamic_grid_item_rectangle: IDynamicGridItemRectangle | undefined;
  icon_text_list_item: IIconTextListItem | undefined;
  icon_text_tile: IIconTextTile | undefined;
  filter_pill: IFilterPill | undefined;
  /**
   * Only to be used for filterable carousel
   */
  product_token: IProductToken | undefined;
  brand_information_header_tile: IBrandInformationHeaderTile | undefined;
  delivered_brand_order: IDeliveredBrandOrder | undefined;
  avatar_info_card_tile_data: IAvatarInfoCardTileData | undefined;
  image_fan_tile: ILayoutElementImageFanTile | undefined;
}
